module.exports = __webpack_public_path__ + "static/media/img_wear-insert-01.efc637ec.svg";